// extracted by mini-css-extract-plugin
export default {"fact":"CountWrapper_fact__yON9x","factKey":"CountWrapper_factKey__52YGN"};